import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import {
    createBrowserRouter,
    RouterProvider,
    Routes,
    Route,
    Link as RouteLink,
    useNavigate,
    useLocation,
    Navigate,
    Outlet,
    useHref
  } from "react-router-dom";

import { useTheme } from '@mui/material';
import {useAuth} from '../context/AuthContext'

import {returnBasenameUrl} from '../utils'

function Copyright(props: any) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://ksr-group.gr/">
          KSR Hellas
        </Link>{' 2024.'}
      </Typography>
    );
  }

function Sidelogin() {
    const theme = useTheme();
    // const basename = useHref('/'); 
    const basename = returnBasenameUrl();
    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuth();
    const [loading, setLoading]=React.useState(false)

    function handleSubmit(event: React.FormEvent<HTMLFormElement>){
        setLoading(true)
        event.preventDefault();
        let from = location.state?.from?.pathname || "/";
        const data = new FormData(event.currentTarget);
        // console.log({
        //    username: data.get('username'),
        //    password: data.get('password'),
        // });
        if(data.get('username')!==null && data.get('password')!==null){
            let username = `${data.get('username')?.toString()}`;
            let password = `${data.get('password')?.toString()}`;
            auth.signin(username, password, (motoaccesslevel, partsaccesslevel,aftersaccesslevel ) => {
                // console.log("=== auth.signin callback ...navigate to /")
                setLoading(false)
                navigate("/", { replace: true });
            }) 
        }
        // setLoading(false)
    }

    /* {"action":"login","success":true,"clientid":"9J8p9JL2OrXpJsfuTa1eUIKsC4L4M692M55dLr8bDqHrLoKtHMnIIK5uSaqbDZ1uTqqbDKLbGqb4P451UKXqLs95S5abDKHvLL4bDqGbDqHLLN9nPLH1SM52GN1rHN9OSqqbDqLbTLTsJ75CIK5qLKebDqHLM40bDZ1sJtCbDKDYGYKtGoKsC6KbDKGbDKLPHLL7M710LqnoGqebDZ1b9JL3Nr55LMjD9JOmGLLiK4H6U4P0OoKtH6LLJqbIG450Oq16I5LLMbLLHMSbDKCbDZ16GNXNLr59TLfK9JL3K4HNR652RabmM5frHKjo9JT4PLLoGG",
    "userid":"305",
    "company":"1001",
    "branch":"1000",
    "appid":"1010",
    "module":"13",
    "refid":"257",
    "modulename":"\u03a0\u03b5\u03bb\u03ac\u03c4\u03b7\u03c2",
    "userinfo":{
        "WEBUSERNAME":"tstylianop","WEBUSEREMAIL":"tstylianop2@gmail.com",
        "LCOMPANY":1001,"LBRANCH":1000,
        "bus":[
            {"WEBSERVICE":1010,
              "bu":10,
              "buname":"Motocycles",
              "trdr":257,
              "trdbame":"STYLIANOP",
              "trdbranch":0,
              "trdbrnname":"",
              "trdafm":"044224042",
              "trdemail":"tstylianop@gmail.com",
              "whs":"10,11",
              "accesslevel":2},
            {"WEBSERVICE":1020,
              "bu":20,
              "buname":"MotoParts",
              "trdr":257,"trdbame":"STYLIANOP","trdbranch":0,"trdbrnname":"","trdafm":"044224042","trdemail":"tstylianop@gmail.com",
              "whs":"2",
              "accesslevel":2}]}}

    */
    
      return(
        <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid size={{ sm: 4, md: 7 }}
              sx={{
                backgroundImage:
                  `url("${basename}images/Screenshot_ksr-group.gr.jpeg")`,

                backgroundColor: (t) =>
                  t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                backgroundSize: 'cover',
                backgroundPosition: 'left',
              }}
            />
            <Grid size={{xs:12, sm: 8, md: 5 }} component={Paper} elevation={6} square>
              <Box
                sx={{
                  my: 8,
                  mx: 4,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                  Sign in
                </Typography>
                <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label="User Name"
                    name="username"
                    autoComplete="email"
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                  />
                  {/* <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Remember me"
                  />*/}

                  { (loading===false) && 
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Sign In
                  </Button>
                  }
                  { (loading===true) && <LinearProgress /> }

                  {/* unseless in production  */}
                  { /*
                  <Grid container>
                    <Grid item xs>
                      <Link href="news" variant="body2">
                        News
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link href="tests" variant="body2">
                        {"Tests"}
                      </Link>
                    </Grid>
                  </Grid> 
                  */ }
                  <Copyright sx={{ mt: 5 }} /> 
                </Box>
              </Box>
            </Grid>
        </Grid>
      )

  
}

export default Sidelogin;